import React, {useEffect} from 'react';
import {
  ActionModal,
  ErrorModal,
  FormInput,
  useErrorHandler,
} from '../../../../shared';
import {useProjectTransferForm} from '../../model';
import {useTransferAmountInput} from '../../lib/useTransferAmountInput';
import {ProjectTransferConfirmModal} from '../ProjectTransferConfirmModal';

interface ProjectTransferModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  fundraiserId: string;
}

export const ProjectTransferModal = ({open, setOpen, fundraiserId}: ProjectTransferModalProps) => {
  const {handleError, isErrorModalOpen, errorInfo, handleClose} = useErrorHandler({
    resourceName: 'Трансфер средств проекта',
    title: 'Ошибка при внесении средств',
  });

  const {
    values,
    errors,
    touched,
    isLoading,
    submitError,
    resetForm,
    submitForm,
    setFieldValue,
    setFieldTouched,
    showConfirmModal,
    setShowConfirmModal,
    formDataForConfirm,
    handleConfirmTransfer,
  } = useProjectTransferForm({
    fundraiserId,
    setOpen,
    onSuccess: () => {
      setOpen(false);
    },
  });

  const amountInput = useTransferAmountInput(values.amount, (amount) => {
    setFieldValue('amount', amount);
    setFieldTouched('amount', true, false);
  });

  // Обработка ошибок
  useEffect(() => {
    if (submitError) {
      handleError(submitError as any);
    }
  }, [submitError, handleError]);

  // Очистка формы при открытии модального окна
  useEffect(() => {
    if (open) {
      resetForm();
    }
  }, [open, resetForm]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Внести средства проекта'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Сумма доната"
          placeholder="Сумма доната"
          name="amount"
          type="text"
          {...amountInput}
          error={touched.amount && errors.amount}
          isRequired
        />
      </ActionModal>

      <ProjectTransferConfirmModal
        open={showConfirmModal}
        setOpen={setShowConfirmModal}
        formData={formDataForConfirm}
        onConfirm={handleConfirmTransfer}
        isLoading={isLoading}
      />

      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
